import { render } from "./App.vue?vue&type=template&id=bf3588f4&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=bf3588f4&lang=less"

import exportComponent from "/Users/ultrapixel/Downloads/Programmierung/github/vuejs/rgba-to-hex/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__